
import * as React from 'react';
// import {useState, useEffect } from 'react';
import {Link, useNavigate} from 'react-router-dom';
// import $ from 'jquery';
import '../App.css';
import { setupBlockchain } from './Create';
// import { setupBlockchainConnection } from '../ResponsiveAppBar';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
// import Paper from '@mui/material/Paper';
// import { styled } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Stack from '@mui/material/Stack';

import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// import FormGroup from '@mui/material/FormGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Switch from '@mui/material/Switch';

// Set base URLs & IDs
    let EXAMPLES_ADDRESS;
    if (process.env.NODE_ENV === "development") {
        console.log("local environment");
        EXAMPLES_ADDRESS = process.env.REACT_APP_EXAMPLES_ADDRESS_LOCAL;
    } else {
        console.log("production environment");
        EXAMPLES_ADDRESS = process.env.REACT_APP_EXAMPLES_ADDRESS_PRODUCTION;
    }


function FAQ() {

		const navigate = useNavigate();

    // Jump to prediction example pages
            function predictionExample(number) {
                navigate('/prediction?index=' + number + '&addr=' + EXAMPLES_ADDRESS);
            }

    // Set dark theme
        const darkTheme = createTheme({
            palette: {
                mode: 'dark',
            },
        });
    // Set dim theme
		const dimtheme = createTheme({
			palette: {
				neutral: {
					main: 'rgb(159, 159, 159)',
					contrastText: '#fff',
				},
			},
		});


    return (

        <div className="faq-page">

        <div className="App-container">
            <ThemeProvider theme={darkTheme}>

            <CssBaseline />
                <Container maxWidth="sm">

                    {/* Mobile Nav Buttons*/}

                        <div className="mobile-nav-buttons" style={{border:"0px solid red", margin:"auto", marginTop:"-15px", display:"none"}}>

                            <Button size="small" sx={{ my: 2 }} style={{ marginLeft:"5px", marginTop:'17px'}} >
                                <Link className="nav-menu-mobile" to="/create" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>Create</Link>
                            </Button>

                            <div style={{ color:'gray', display:'inline-block' }}>|</div> 

                            <Button size="small" sx={{ my: 2 }} style={{ marginLeft:"3px", marginTop:'17px'}}>
                                <Link className="nav-menu-mobile" to="/browse" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>Browse</Link>
                            </Button>

                            <div style={{ color:'gray', display:'inline-block' }}>|</div> 
                            
                            <Button size="small" sx={{ my: 2 }} style={{ marginLeft:"-5px", marginTop:'17px'}}>
                                <Link className="nav-menu-mobile" to="/faq" style={{ fontSize:'16px', fontWeight:'normal', color:'white' }}>FAQ</Link>
                            </Button>
                        </div>

                    <div className="app-title" style={{ margin:"13px 0px 10px" }}>
                        PROJECT TYPE-1
                    </div>

                    <div className="page-title" id="faq-title" style={{ marginTop: "-5px", marginBottom: "-25px", color:"rgb(155, 155, 155)" }}>Frequently Asked Questions</div>

                    {/* <br/><div style={{marginTop: "3px", marginBottom: "0px", fontSize: "28px", color: "gray", fontWeight: "300"}}>Frequently Asked Questions</div> */}

                    <br/><br/><br/>

                    <div className='hyperlink'>

                        <Accordion>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{backgroundColor:'rgb(54, 57, 69)', color:'rgb(222, 222, 222', textAlign:'left' }}
                            >
                            <Typography>
                                What is Project Type-1?
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails 
                                style={{backgroundColor:'rgb(36, 38, 46)', border:'1px solid rgb(67, 72, 84)', color:'rgb(230, 230, 230', borderTop:'2px solid rgb(46, 46, 46)', textAlign:'left', padding:'0px 17px'}}
                            >
                            <div style={{lineHeight:'1.8'}}>
                                <p>'Project Type-1' is a Psiscope web app designed to facilitate psi/ESP/RV projects utilizing a <strong>single-blind</strong> setup optimal for a projet involving: 1) a tasker - and/or project manager - who assigns a hidden 'target', and 2) participants who subsequently try to perceive it using psi only, without <i>any</i> clues.</p>
                                
                                <p>Project Type-1 utilizes blockchain technology in order to ensure verifiability for all key information thus eliminating any need for trust in the process. Blockchain technology's unique immutability is applied to both the tasking/target side and the psi perception (participants) side.</p>
                                
                                <p>Long story short, what happens is that only the information's "hashes" or cryptographic digital 'fingerprints' get stored on blockchain. The original information (text or file) remains hidden until the project is closed. Normally there would be no way for the tasker to prove the 'target'/'tasking' has not been changed (i.e. cheating on the part of the tasker). With blockchain, this is now possible, eliminating the need for trust.</p>

                                The whole process is as follows:
                                <ol>
                                    <li>Tasker creates a project and assigns a target.</li>
                                    <li>Tasker hashes the target and stores the hash on blockchain.</li>
                                    <li>Participants try to psychically percieve the target without any clues.</li>
                                    <li>Participants commit their psychic information (hashes) to blockchain, making it immutable and permanent.</li>
                                    <li>Tasker reveals the target (text and/or file).</li>
                                    <li>The system (web app) hashes the revealed target and compared it to the hash on blockchain. If identical, the target is verified.</li>
                                    <li>Participants can verify the revealed target by hashing it themselves and comparing it to the hash stored on blockchain (which cannot be altered or deleted).</li>
                                </ol>
																
                                <p>Project Type-1 is part of Psiscope's broader initiative to normalize the use of blockchain and Web3 technologies for psi-related purposes, with the ultimate goal of pushing psi into the realm of consensus reality and pave the way for its integration with mainstream society.</p>
                            </div>
                            </AccordionDetails>
                        </Accordion><br/>

                        <Accordion>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{backgroundColor:'rgb(54, 57, 69)', color:'rgb(222, 222, 222', textAlign:'left'}}
                            >
                            <Typography>
                                What are Web3, blockchain, and wallets?
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails 
                                style={{backgroundColor:'rgb(36, 38, 46)', border:'1px solid rgb(67, 72, 84)', color:'rgb(230, 230, 230', borderTop:'2px solid rgb(46, 46, 46)', textAlign:'left', padding:'0px 17px'}}
                            >
                            <div style={{lineHeight:'1.8'}}>
                                <p>Web 3 represents the next generation of the internet, aiming to create a more decentralized and user-centric online experience. Unlike Web 2.0, which relies heavily on centralized servers and platforms controlled by a few large entities, Web 3 leverages blockchain technology to distribute data and applications across a decentralized network of computers. This shift aims to give users more control over their data, enhance privacy, and create new opportunities for peer-to-peer interactions and transactions without intermediaries. Web 3 encompasses a wide range of applications, including decentralized finance (DeFi), digital ownership (NFTs etc.), decentralized autonomous organizations (DAOs), verifiable credentials, self-sovereign identity (SSI), decentralized social networks, etc., each built to empower users and promote transparency.</p>

                                <p>At the core of Web 3 is blockchain technology, a distributed database system that securely records data and transactions across multiple computers in a way that is immutable and transparent. Each block in the chain contains a list of transactions, and once a block is added to the chain, it cannot be altered without changing all subsequent blocks, making it highly secure. Blockchain technology enables trustless interactions, where parties can transact directly without needing to trust a central authority. This has profound implications for various sectors, including finance, supply chain management, and digital identity.</p>

                                <p>Wallets are essential tools in the Web 3 ecosystem, serving as the interface between users and the blockchain. They are digital applications that allow users to store, send, and receive cryptocurrencies and other digital assets. Wallets come in various forms, including software wallets (applications on computers or smartphones), hardware wallets (physical devices), and paper wallets (physical printouts of private and public keys). Each wallet contains private keys that grant access to the user's assets on the blockchain. Proper management of these keys is crucial, as losing them means losing access to the associated assets. Wallets also enable users to interact with decentralized applications (dApps), facilitating a wide range of activities, from trading digital assets to participating in governance decisions of decentralized organizations.</p>

                                <p>If you would like to learn more, check out <a href="https://learn.metamask.io/" target="_blank">"MetaMask Learn"</a> for a great overview and the "Web3 101 Course".</p>
                            </div>
                            </AccordionDetails>
                        </Accordion><br/>

                        <Accordion>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{backgroundColor:'rgb(54, 57, 69)', color:'rgb(222, 222, 222', textAlign:'left' }}
                            >
                            <Typography>
                                How do I get started?
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails 
                                style={{backgroundColor:'rgb(36, 38, 46)', border:'1px solid rgb(67, 72, 84)', color:'rgb(230, 230, 230', borderTop:'2px solid rgb(46, 46, 46)', textAlign:'left', padding:'0px 17px'}}
                            >
                            <div style={{lineHeight:'1.8'}}>

                                <p>To use blockchain for the purpose of permanently storing digital information, you need a Web3/crypto wallet which usually takes the form of a web browser plugin or a mobile app. Even though it's called "wallet", here on Psiscope we use it more as a portal to blockchain. Usually the only payment you'll make while using Psiscope is 'gas', a <i>tiny</i> transaction fee paid to the blockhain network itself (not to Psiscope) for the cost of storing data. This is a process fundamental to how public blockchains work.</p>

                                <p>Setting up your crypto wallet can be a bit of a pain but it's well worth it. Once this step is done, the stressful part is behind you.</p>
                                
                                <p>Here is a quick overview of how to set up your crypto wallet (for more detailed instructions, see the other FAQ entries):</p>

                                <ol>
                                  <li>
                                    <strong>You need to download and install a crypto wallet</strong>, either a desktop browser extension or a mobile app. The most popluar wallet is MetaMask. Coinbase' wallet is also a good choice. If you're using your phone, you have to access Psiscope through a browser <em>inside</em> a mobile wallet app.
                                  </li>
                                  <li>
                                    <strong>You need to have some 'ether'/ETH crypto(and have it on the Base network) in your wallet.</strong> so you can pay for the network's very low transaction fees. (Follow the instructions provided elsewhere in the FAQ.)
                                  </li>
                                  <li>
                                    Your ETH has to be on the 'Base' network which is a 'layer 2' network Coinbase built on top of the Ethereum blockchain (designed to make transactions cheaper and faster). Please follow the instructions in another FAQ entry.
                                  </li>
                                </ol>

                                <p>
                                  It may sound daunting, but it's really not that bad if you just follow the instructions in the FAQ.
                                </p>

                            </div>
                            </AccordionDetails>
                        </Accordion><br/>

                        <Accordion>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                            style={{backgroundColor:'rgb(54, 57, 69)', color:'rgb(222, 222, 222', textAlign:'left'}}
                            >
                            <Typography>
                                I don't have a crypto wallet yet. What do I need to do?
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                style={{backgroundColor:'rgb(36, 38, 46)', border:'1px solid rgb(67, 72, 84)', color:'rgb(230, 230, 230', borderTop:'2px solid rgb(46, 46, 46)', textAlign:'left', padding:'0px 17px'}}
                            >
                            <div style={{lineHeight:'1.8'}}>

                            <p>If you're completely new to this, check out the following Youtube videos for concise explainations of MetaMask (largely applicable to Coinbase Wallet as well):</p>

                            <ul>
                                <li>Simplest: <a href="https://www.youtube.com/watch?v=YVgfHZMFFFQ" target="_blank">What is MetaMask?"</a></li>
                                <li>More detailed: <a href="https://www.youtube.com/watch?v=byWul4xOBx0" target="_blank">"What is Metamask? Simple Cryptocurrency Wallet"</a></li>
                                <li>Step-by-step instruction: <a href="https://www.youtube.com/watch?v=GNPz-Dv5BjM" target="_blank">"Getting Started with MetaMask"</a></li>
                            </ul>

                            <p>Finding and Installing MetaMask or Coinbase Wallet:</p>

                            <ol>
                                <li>Download and install <a href="https://metamask.io" target="_blank">MetaMask</a> or <a href="https://www.coinbase.com/wallet" target="_blank">Coinbase Wallet</a> from their own websites, or...</li>
                                <li>Go to the official app store for your browser. (Note: Apple's desktop Safari browser is not compatible with any of the wallet plugins.)</li>
                                <li>Search for "MetaMask" or "Coinbase Wallet" and select the official extension (for computer) or app (for mobil device).</li>
                                <li>Click on "Add to Chrome" or "Get" to install the extension or app.</li>
                                <li>Once the installation is complete, click on the MetaMask or Coinbase Wallet icon in your browser or on your device.</li>
                            </ol>

                            Setting Up MetaMask or Coinbase Wallet:

                            <ol>
                                <li>Click on "Create a Wallet" and follow the prompts to set up your account, including creating secure password. </li>
                                <li>Write down or securely store your seed phrase. </li>
                                <li>Connect your MetaMask wallet to a blockchain network, such as Ethereum, Base, Polygon, etc. </li>
                            </ol>

                            <p>Note 1: If you connect your wallet to Psiscope, your wallet should automatically switch to the 'Base' network.</p>

                            <p>Note 2: To access Psiscope/Web3 apps on your MOBILE DEVICE, you need to use a special browser <i>inside</i> your MetaMask/Coinbase mobile app, not through your normal web browser.</p>

                            <p>Note 3: Always make sure to keep your seed phrase safe and secure, as it is the only way to recover your account if you forget your password. And never share your private key with <em>anyone</em>!</p>
                            </div>
                            </AccordionDetails>
                        </Accordion><br/>

                        <Accordion>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                            style={{backgroundColor:'rgb(54, 57, 69)', color:'rgb(222, 222, 222', textAlign:'left'}}
                            >
                            <Typography>
                                How do I get ETH (crypto/token) & put it in my wallet?
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                style={{backgroundColor:'rgb(36, 38, 46)', border:'1px solid rgb(67, 72, 84)', color:'rgb(230, 230, 230', borderTop:'2px solid rgb(46, 46, 46)', textAlign:'left', padding:'0px 17px'}}
                            >
                            <div style={{lineHeight:'1.8'}}>
                                <p>To buy ETH and use it on the Base (layer 2) network, follow these steps:</p>

                                <strong>Use Coinbase</strong>

                                <ol>
                                    <li><strong>Create an account</strong> on <a href="https://www.coinbase.com/" target="_blank">Coinbase</a> if you haven't already.</li><br/>

                                    <li><strong>Purchase some ETH (ether)</strong>. Here is a <a href="https://www.coinbase.com/how-to-buy/ethereum" target="_blank">step-by-step instruction</a>. You only need a very small amount - as little as $1 (USD) should be plenty.<br/>
                                        <ul>
                                            <li>Navigate to "Buy & Sell".</li>
                                            <li>Select Ethereum (ETH).</li>
                                            <li>Enter the amount you want to buy and complete the purchase.</li>
                                        </ul><br/>
                                    </li>

                                    <li><strong>Find your wallet's address</strong>: In MetaMask, <a href="https://support.metamask.io/configure/accounts/how-to-view-your-account-details-and-public-address/" target="_blank">here is how you</a> find/copy your wallet address. In Coinbase Wallet, you should see your address by clicking the 'Receive' button. (It may be labeled 'Ethereum address'.) If you you have multiple accounts/addresses in your wallet, make sure to select the one you want first.</li><br/>

                                    <li><strong>Send the ETH to your wallet</strong>: From inside the Coinbase website (not wallet):<br/>

                                        <ul>
                                            <li>Go to "Send & Receive" in Coinbase.</li>
                                            <li>Select ETH as the asset.</li>
                                            <li>Paste your wallet address in the recipient field.</li>
                                            <li>In the network selection, <strong>choose 'Base'</strong> (⚠️ Do NOT select Ethereum or another chain).</li>
                                            <li>Confirm the amount and finalize the transaction.</li>
                                        </ul>
                                    </li><br/>

                                    <li><strong>Confirm ETH in Your Wallet</strong>:<br/>
                                        <ul>
                                            <li>Open your wallet.</li>
                                            <li>If you're using Metamask, <strong>switch the network to 'Base' (otherwise you won't see the ETH sent).</strong>. With Coinbase Wallet, you can stay on the main page/panel.</li>
                                            <li>You should see the ETH arrive within a few minutes.</li>
                                        </ul>
                                    </li><br/>
                                    And now you're all set. You can use the ETH token for gas and transactions on Base!
                                </ol>

                                <div>----------</div>

                                <strong>Alternative Method:</strong> If you already have some ETH in your wallet but it's on the Ethereum mainnet, you can transfer it to the Base network (this process is more expensive). Here's how:

                                    <ol>
                                        <li>Go to <a href="https://superbridge.app/base" target="_blank">Base Bridge</a></li>
                                        <li>Connect your wallet</li>
                                        <li>Select Ethereum Mainnet → Base</li>
                                        <li>Enter ETH amount & confirm the transaction.</li>
                                    </ol>

                            </div>
                            </AccordionDetails>
                        </Accordion><br/>

                        <Accordion>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            style={{backgroundColor:'rgb(54, 57, 69)', color:'rgb(222, 222, 222', textAlign:'left'}}
                            >
                            <Typography>
                                Is it safe to connect a wallet to websites?
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails 
                                style={{backgroundColor:'rgb(36, 38, 46)', border:'1px solid rgb(67, 72, 84)', color:'rgb(230, 230, 230', borderTop:'2px solid rgb(46, 46, 46)', textAlign:'left', padding:'0px 17px'}}
                            >
                            <div style={{lineHeight:'1.8'}}>
                                <p>A crypto/Web3 wallet is a digital tool used to securely store, manage, and transfer cryptocurrency assets. The wallet operates as a digital account that can receive and send transactions on a blockchain network.</p>

                                <p>Reputable wallets like MetaMask and Coinbase Wallet are secure and safe to use as long as the user is careful who is ultimately responsible for safety by securely managing their private keys.</p>

                                <p>Connecting a wallet to a decentralized application (dApp) or website is a common and normal process in the world of web3. It serves as the equivalent of "logging in" with a username and password, but instead of using a centralized account, it uses your own personal cryptocurrency wallet.</p>

                                <p>When you connect your wallet to a dApp/website, you are simply allowing it, always done with your permission and under your control, to interact with your blockchain assets and data, such as Ethereum and its coin, without having to reveal your private keys. The connection is secured through the use of public-private key cryptography, which allows you to sign transactions and interact with the dApp or website without compromising your assets or personal information. This is very normal and how Web3 is fundamentally designed to work.</p>

                                <p>With Psiscope web apps, all you are doing with your wallet is paying a miniscule transactoin fee ("gas"), usually just a few cents (US), directly to the blockchain network, and nothing to Psiscope or anyone else. You are simply paying the blockchain network itself to have your information recorded on the blockchain. The transaction is minimal and so is its risk.</p>

                                <p>If you already have a wallet with digital assets in it but somehow feel paranoid about using it with Psiscope, you could simply create a new account inside your wallet and put a little crypto in it and use the account exclusively with Psiscope. This way it's isolated and your paranoid mind can rest easy.</p>
                            </div>
                            </AccordionDetails>
                        </Accordion><br/>

                        <Accordion>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                            style={{backgroundColor:'rgb(54, 57, 69)', color:'rgb(222, 222, 222', textAlign:'left'}}
                            >
                            <Typography>
                                What is this blockchain transaction fee ('gas') about?
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                style={{backgroundColor:'rgb(36, 38, 46)', border:'1px solid rgb(67, 72, 84)', color:'rgb(230, 230, 230', borderTop:'2px solid rgb(46, 46, 46)', textAlign:'left', padding:'0px 17px'}}
                            >
                            <div style={{lineHeight:'1.8'}}>
                                <p>A transaction fee, also known as "gas," is a necessary cost for executing a transaction on a blockchain network. This fee is required to compensate the network's participants, such as miners or validators, for the computational resources they use to validate and process the transaction.</p>

                                <p>The amount of gas required for a transaction is determined by the complexity of the operation being performed, such as transferring funds or executing a smart contract. Users should pay attention to the gas price, as it affects the speed at which their transaction is processed. A higher gas price will result in the transaction being processed more quickly, but will also increase the cost of the transaction. A user must have a sufficient amount of crypto in the wallet or the transaction will fail.</p>

                                <p>With the Base network Psiscope uses, the fee is very low (practically free without actually being free) and the transactions usually take only several seconds. So normally you don't have to worry too much about the gas price. What the wallet automatically suggests should usually be acceptable.</p>
                            </div>
                            </AccordionDetails>
                        </Accordion><br/>

                        <Accordion>
                            <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                            style={{backgroundColor:'rgb(54, 57, 69)', color:'rgb(222, 222, 222', textAlign:'left'}}
                            >
                            <Typography>
                                What's the point of "hashing"?
                            </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                                style={{backgroundColor:'rgb(36, 38, 46)', border:'1px solid rgb(67, 72, 84)', color:'rgb(230, 230, 230', borderTop:'2px solid rgb(46, 46, 46)', textAlign:'left', padding:'0px 17px'}}
                            >
                            <div style={{lineHeight:'1.8'}}>
                                <p>Hashing means the information will be obfuscated or only the cryptographic "fingerprint" of your information will be recorded on blockhcain.</p>

                                <p>Cryptographic hashing is a process of taking an input data of any length and generating a deterministric, fixed-length output, called a hash or a digest, using a mathematical algorithm. It might look something like this:</p>

                                <p style={{wordWrap: "break-word"}}>'0x72538C66ba8c23da2030407e8F22861239C0CDBd'</p>
                                
                                <p>The hash is unique to the input data and any small change in the input data will result in a completely different hash. This property makes cryptographic hashing useful for verifying data integrity, detecting data tampering, and creating digital signatures. Cryptographic hashes are designed to be one-way, meaning it is practically impossible to derive the original input data from the hash. Commonly used cryptographic hashing algorithms include MD5, SHA-1, and SHA-256. Psiscope uses SHA-256.</p>

                                <p>On Psiscope you're sometimes given an option to hash your information and hide the original input from others. In this setup, even without disclosing the information beforehand, you would still be able to irrefutably prove to others that you did indeed have that information at the time specified by the immutable timestamp.</p>

                                <p>Proving the validity of your hashed data would involve you providing the original input (text or file), hashing it again (done through Psiscope or elsewhere), then showing that it matches the hash already recorded on blockchain with a timestamp.</p>
                            </div>
                            </AccordionDetails>
                        </Accordion><br/>

                    </div>

                </Container>

            </ThemeProvider>
            <br/><br/><br/><br/>
        </div>

        </div> // closing className="faq=page"

    );
}

export default FAQ;